import { USER_ACTION_TYPES } from "./user.types.js";
import { GRADIENT_DATA } from "../../data/theme-data/gradient-data.js";

const USER_INITIAL_STATE = {
    user: null,
    authIsReady: false,
    teamIndex: Math.floor(Math.random() * Object.keys(GRADIENT_DATA).length),
    activityLog: [],
    recentlyViewed: [],
    cardCount: null,
    tokens: 0,
    emailVerificationPending: false,
    userCache: null,
    cacheTimestamp: null
};

export const userReducer = (state = USER_INITIAL_STATE, action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case USER_ACTION_TYPES.LOG_IN:
            return { ...state, user: payload };
        case USER_ACTION_TYPES.LOG_OUT:
            return { ...state, user: null }; // Keep the existing teamIndex
        case USER_ACTION_TYPES.AUTH_IS_READY:
            return { ...state, user: payload, authIsReady: true };
        case USER_ACTION_TYPES.SET_TEAM_INDEX:
            return { ...state, teamIndex: payload };
        case USER_ACTION_TYPES.UPDATE_RECENTLY_VIEWED:
            return { ...state, recentlyViewed: payload };
        case USER_ACTION_TYPES.SET_CARD_COUNT:
            return { ...state, cardCount: payload };
        case USER_ACTION_TYPES.UPDATE_TOKENS:
            if (state.user) {
                const updatedUser = {
                    ...state.user,
                    tokens: (state.user.tokens || 0) + payload
                };
                return { ...state, user: updatedUser };
            }
            return state;
        case USER_ACTION_TYPES.SET_EMAIL_VERIFICATION_PENDING:
            return { ...state, emailVerificationPending: payload };
        case USER_ACTION_TYPES.SET_USER_CACHE:
            return { 
                ...state, 
                userCache: payload.data, 
                cacheTimestamp: payload.timestamp 
            };
        case USER_ACTION_TYPES.CLEAR_USER_CACHE:
            return { 
                ...state, 
                userCache: null, 
                cacheTimestamp: null 
            };
        case USER_ACTION_TYPES.RESET_USER_STATE:
            // Preserve teamIndex when resetting - only reset user-related data
            const preservedTeamIndex = state.teamIndex;
            return {
                user: null,
                authIsReady: false,
                teamIndex: preservedTeamIndex, // Keep the existing teamIndex
                activityLog: [],
                recentlyViewed: [],
                cardCount: null,
                tokens: 0,
                emailVerificationPending: false,
                userCache: null,
                cacheTimestamp: null
            };
        default:
            return state;
    }
};